export default class CDSConfig {

    constructor() {
        this.cdsUrl = '';
        this.cdsLibraryId = '';
        this.cdsUseDefaultUsername = true;
        this.cdsUsername = '';
        this.cdsPassword = '';
    }

}
